export const ERROR_CODE_MCU_CONTROL_ROOM = [
    {
        key: 'ROOM_NOT_FOUND',
        message: 'mcu.error.roomNotFound'
    }
]

export const ERROR_CODE_GROUP_USERS = {
    1: 'phonebook.errors.userGroupNotFound',
    2: 'phonebook.errors.dontHavePermission',
    3: 'phonebook.errors.accountNotFound',
    4: 'phonebook.errors.accountNotActive',
    5: 'phonebook.errors.accountAlreadyInGroup',
    6: 'phonebook.errors.ownerAlreadyInGroup'
}

export const ERROR_CODE_REMOVE_GROUP_USERS = {
    1: 'phonebook.errors.userGroupNotFound',
    2: 'phonebook.errors.dontHavePermission',
    3: 'phonebook.errors.memberNotFound',
    4: 'phonebook.errors.memberNotActive',
    5: 'phonebook.errors.cantRemoveOwner',
}

export const ERROR_CODE_GROUP = {
    1: 'phonebook.errors.accountNotFound',
    2: 'phonebook.errors.accountNotActive'
}

export const ERROR_CODE_REMOVE_GROUP = {
    1: 'phonebook.errors.userGroupNotFound',
    2: 'phonebook.errors.dontHavePermission',
}